import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { IFilter, initFilterData } from "./index";
import TableFilterAcionts from "../TableFilterAcionts";

interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: (filter?: IFilter) => void;
}

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <TextField
          label="Full Name"
          variant="standard"
          value={filter.data.name}
          name="name"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
        <TextField
          label="Wallet Address"
          variant="standard"
          value={filter.data.wallet_address}
          name="wallet_address"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
      </Box>
      <TableFilterAcionts
        disableCancel={false}
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleSearch(initFilterData);
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
